import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from "@angular/core";
import { PreloadAllModules, provideRouter, withPreloading } from "@angular/router";
import { routes } from "./app-routing.module";
import { BsDatepickerModule, BsDaterangepickerConfig } from "ngx-bootstrap/datepicker";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { DATEPICKER_CONFIG } from "./shared/constants/datepicker.config";
import { ToastrModule } from "ngx-toastr";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { ModalModule } from "ngx-bootstrap/modal";
import { TabsModule } from "ngx-bootstrap/tabs";
import { lastValueFrom } from "rxjs";

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),

    // All forRoot() module providers merged into a single call
    importProvidersFrom(
      BsDatepickerModule.forRoot(),
      ModalModule.forRoot(),
      TabsModule.forRoot(),
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpTranslateLoader,
          deps: [HttpClient],
        },
      }),
      ToastrModule.forRoot({
        positionClass: 'toast-bottom-right',
        preventDuplicates: true,
        closeButton: false,
        timeOut: 3000
      })
    ),

    {
      provide: BsDaterangepickerConfig,
      useValue: DATEPICKER_CONFIG
    },

    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      translate.addLangs(['en', 'de', 'fr', 'it']);
      translate.setDefaultLang('en');
      const storedLang = localStorage.getItem('defaultUserLanguage');
      const browserLang = translate.getBrowserLang();
      const langToUse = storedLang
        ? JSON.parse(storedLang)
        : (browserLang?.match(/en|de|fr|it/) ? browserLang : 'en');
      return lastValueFrom(translate.use(langToUse));
    })
  ]
};
